"use client";

import styles from "../css/ConfirmationModal.module.css";

const ConfirmationModal = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>
          ×
        </button>

        <div className={styles.successIcon}>
          <div className={styles.checkmark}>✓</div>
        </div>

        <div className={styles.message}>{message}</div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
